import api from "./apiClient";



// ADS
const getAllAds = () => {
    return api.get(`/api/ads`);
}

const createAds = (data: any) => {
    return api.post(`/api/ads`, data);
}


const updateAds = (id: any, data: any) => {
    return api.put(`/api/ads/${id}`, data);
}

const adsDelete = (id: any) => {
    return api.delete(`/api/ads/${id}`);
}


export {
    getAllAds,
    createAds,
    updateAds,
    adsDelete
}